import { Separator } from "@/components/ui/separator";
import type { CartLine } from "@/lib/store/cart";

export function CartSummary({ lines, total }: { lines: CartLine[]; total: number }) {
  if (lines.length === 0) {
    return <p className="text-sm text-muted-foreground">No items selected yet.</p>;
  }

  return (
    <div className="space-y-3">
      {lines.map((line) => (
        <div key={line.productId} className="flex items-start justify-between gap-3 text-sm">
          <span>
            {line.quantity} &times; {line.name}
          </span>
          <span className="shrink-0 font-medium tabular-nums">
            ${(Number(line.unitPrice) * line.quantity).toFixed(2)}
          </span>
        </div>
      ))}
      <Separator />
      <div className="flex items-center justify-between font-semibold">
        <span>Total</span>
        <span className="tabular-nums">${total.toFixed(2)}</span>
      </div>
    </div>
  );
}
